import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import { loadCourses, loadSubs } from 'src/actions'
import axios from '../../../api'
import * as R from 'ramda'

import styled, { css } from 'styled-components'
import {
  Button,
  Container,
  Form,
  Grid,
  Header,
  Loader,
} from 'semantic-ui-react'
import '../../../assets/styles/animations.css'

import FZExclamation from '../../FZExclamation'
import HelmetMetaData from 'src/components/HelmetMetaData'

import getCourseInfo from '../../../util/courseInfo'
import useMobile from '../../../hooks/useMobile'
import { Transition } from '@mantine/core'
import useStaffRoles from 'src/hooks/useStaffRoles'
import useAPI from 'src/hooks/useAPI'

import betaLabel from 'src/assets/course_cards/beta_label_flipped.svg'
import useNavigationContext from 'src/hooks/context/useNavigationContext'

// TODO: rename "Japanese From Zero! 1 (v8) to "Japanese From Zero! 1"
// and replace the title of the old course with "Japanese From Zero! 1 (v7)"
// when it comes time to launch the new course
const available_jfz_courses = [
  'Japanese From Zero! 5',
  'Japanese From Zero! 4',
  'Japanese From Zero! 3',
  'Japanese From Zero! 2',
  'Japanese From Zero! 1',
  'Korean From Zero! 1',
  'Korean From Zero! 2',
  'Korean From Zero! 3',
  'Kanji From Zero! 1',
  'Kanji From Zero! 2',
]

const available_video_courses = [
  'Fluent in 5!',
  'Hitokoto',
  'Ask a Teacher!',
  'Japanese Topics Mania!',
  'Japanese Daily!'
]

// use ramda to combine the two arrays
const availableCourses = R.union(available_jfz_courses, available_video_courses)

const purchased_courses = ['Kansai Dialect From Zero!']

export const CardDeck = styled.div`
  position: relative;
  min-width: 100%;
  min-height: 250px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  /* align-items: center; */
  flex-wrap: wrap;
  gap: 30px;
  margin-bottom: 30px;
`

const ActiveCard = css`
:after {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  width: 200px;
  height: 250px;
  border-radius: 15px;
  transition: box-shadow 0.2s ease-out;
  animation-name: breathing_gold;
  animation-duration: 1s;
  animation-timing-function: ease-in-out;
  animation-direction: alternate;
  animation-iteration-count: infinite;
}

&:hover::after  {
  box-shadow: 0 0 16px 8px gold;
}
`

export const Card = styled.div`
  box-sizing: border-box;
  position: relative;
  margin: ${(props) => (props.isMobile ? '0 auto' : '0')};
  border: 2px solid var(--jfz-blue);
  border-color: ${(props) => getCourseInfo(props.title).color};
  border-radius: 15px;
  color: white;
  background-image: ${(props) => getCourseInfo(props.title).gradient};
  cursor: pointer;

  max-width: 200px;
  min-width: 200px;
  width: 200px;
  max-height: 250px;
  min-height: 250px;
  height: 250px;
  transition: all 0.2s ease-out;

  .beta-label {
    position: absolute;
    top: 0;
    right: 0;
    width: 50px;
    height: 50px;
  }

  ${(props) => (props.highlighted && ActiveCard)}

  &:hover {
    box-shadow: ${(props) => !props.highlighted && '0 0 12px 8px rgba(0, 0, 0, 0.15)'};
    border-color: ${(props) => getCourseInfo(props.title).color};
  }
  &:hover,
  &:hover .title {
    background-color: ${(props) => getCourseInfo(props.title).color};
  }
  &:hover .title::before {
    // avatar + gradient
    background-size: ${(props) => getCourseInfo(props.title).hover_size}, 100%;
    background-position-x: ${(props) => getCourseInfo(props.title).hover_pos_x},
      100%;
    background-position-y: ${(props) => getCourseInfo(props.title).hover_pos_y},
      100%;
    width: 250px;
    height: 300px;
    top: -232px;
    left: -42px;

    clip-path: polygon(-100% -100%, 100% -100%, 100% 90%, -100% 90%);

    ${(props) => !props.isPublic && 'filter: grayscale(0);'}
  }
  &:hover .title::after {
    // course title
    background-color: ${(props) => getCourseInfo(props.title).color};
  }

  .course-card img:first-child {
    position: absolute;
    z-index: 1;
    top: 0;
  }

  .test-course {
    position: relative;
    margin-top: 100%;
    z-index: 1;

    p {
      font-size: 1.2rem;
      color: white;
      text-align: right;
      padding-right: 5px;
      font-family: 'Mont Heavy';
      transition: all 0.2s ease-out;
    }
  }

  .title {
    position: relative;
    margin-top: 100%;
    object-fit: scale-down;
    z-index: 1;
    transition: all 0.2s ease-out;

    ::before {
      content: '';
      position: absolute;

      top: -196px;
      left: 0px;
      height: 200px;
      width: 196px;
      transition: all 0.2s ease-out;
      z-index: 1;

      border-color: ${(props) => getCourseInfo(props.title).color};

      background-image: url(${(props) => getCourseInfo(props.title).character});
      background-size: ${(props) => getCourseInfo(props.title).size}, 100%;
      background-repeat: no-repeat;
      background-position-x: ${(props) => getCourseInfo(props.title).pos_x},
        100%;
      background-position-y: ${(props) => getCourseInfo(props.title).pos_y},
        100%;

      clip-path: polygon(-100% -100%, 100% -100%, 100% 96%, -100% 96%);

      ${(props) => !props.isPublic && 'filter: grayscale(0.8);'}
    }

    ::after {
      content: '';
      position: absolute;
      top: -14px;
      left: -2px;
      right: 0;
      height: 67px;
      width: 200px;
      z-index: 1;
      border-bottom-right-radius: 15px;
      border-bottom-left-radius: 15px;

      background-color: ${(props) => getCourseInfo(props.title).color};
      background-image: url(${(props) => (props.isPublic && getCourseInfo(props.title).logo)});
      background-size: 150px;
      background-repeat: no-repeat;
      background-position-x: 50%;
      background-position-y: 65%;
      transition: all 0.2s ease-out;

      clip-path: path(
        'M200.5.63v65H.5V.63c22.05,5.2,58.62,8.6,100,8.6S178.45,5.83,200.5.63Z'
      );
    }
  }
`

const NewCourseForm = (props) => {
  const [title, setTitle] = useState('')
  const [identifier, setIdentifier] = useState('')
  const [instructor, setInstructor] = useState('')

  const submit = () => {
    axios
      .post('/course/new', { title, identifier, instructor })
      .then(() => props.onSubmitted())
  }

  return (
    <Form>
      <Form.Input
        required
        value={title}
        label="Title"
        onChange={(_, { value }) => setTitle(value)}
      />
      <Form.Input
        required
        value={identifier}
        label="Identifier"
        onChange={(_, { value }) => setIdentifier(value)}
      />
      <Form.Input
        required
        value={instructor}
        label="Instructor"
        onChange={(_, { value }) => setInstructor(value)}
      />
      <Button onClick={submit} color="green">
        Submit
      </Button>
    </Form>
  )
}

const bringCardIn = {
  in: { transform: 'scale(1) rotate(0)' },
  out: { transform: 'scale(0.5) rotate(-6deg)' },
  transitionProperty: 'transform'
}

export const CourseCard = ({ link, title, showDelay = 0, highlighted = false, beta }) => {
  const [isPublic, setIsPublic] = useState(false)
  const [visible, setVisible] = useState(false)
  const [navigateAway, setNavigateAway] = useState(false)
  const isMobile = useMobile()
  const history = useHistory()
  const [isStaffRole] = useStaffRoles()

  const attemptSetVisible = () => {
    if (isStaffRole
      || (
        available_jfz_courses.includes(title)
        || purchased_courses.includes(title)
        || availableCourses.includes(title)
      )
    ) {
      setVisible(true)
    }
  }

  useEffect(() => {
    if (available_jfz_courses.includes(title)
      || purchased_courses.includes(title)
      || availableCourses.includes(title)
    ) {
      setIsPublic(true)
    }

    if (showDelay > 0) {
      setTimeout(() => {
        attemptSetVisible()
      }, showDelay)
      return
    }

    attemptSetVisible()
  }, [showDelay, isStaffRole])

  const handleNavigateToCourseView = () => {
    setNavigateAway(true)
    setTimeout(() => {
      history.push(link)
      setNavigateAway(false)
    }, 250)
  }

  return (
    <Transition
      // appear={true}
      mounted={visible}
      transition={bringCardIn}
      duration={isMobile ? 700 : 500}
      timingFunction='ease'
      // enter='tw-transform tw-transition tw-ease-in-out tw-duration-500 sm:tw-duration-700'
      // enterFrom='tw-scale-50 tw-opacity-0 tw-rotate-[-6deg]'
      // enterTo='tw-scale-100 tw-opacity-100 tw-rotate-0'
      // leave='tw-transform tw-transition tw-ease-in-out tw-duration-500 sm:tw-duration-700'
      // leaveFrom='tw-scale-100 tw-opacity-100 tw-rotate-0'
      // leaveTo='tw-scale-50 tw-opacity-0 tw-rotate-6'
    >
      {(styles) => (
        <Card
          title={title}
          isPublic={isPublic}
          isMobile={isMobile}
          highlighted={highlighted}
          navigating={navigateAway}
          tabIndex="0"
          onKeyUpCapture={(e) => e.key === 'Enter' && handleNavigateToCourseView()}
          style={styles}
        >
          {beta && <img src={betaLabel} alt="beta" className="beta-label" />}
          <div
            className="course-card no-select"
            onClick={handleNavigateToCourseView}
          >
            <div className="title"></div>
            {!isPublic && (
              <div className="test-course">
                <p>{title}</p>
              </div>
            )}
          </div>
        </Card>
      )}
    </Transition>
  )
}

const CoursesPreviewPage = (props) => {
  const [courses, setCourses] = useState([])
  const [newCourseForm, setNewCourseForm] = useState(false)
  const isMobile = useMobile()
  const { courseInfo: { courseBookmark } } = useNavigationContext()
  const [isStaffRole] = useStaffRoles()
  const [betaStatuses, setBetaStatuses] = useState({})
  const [liveStatuses, setLiveStatuses] = useState({})
  const [betaRes, betaLoading, betaReq] = useAPI('/course/betas/fetch')
  const [liveRes, liveLoading, liveReq] = useAPI('/course/live/fetch')

  useEffect(() => {
    // console.log(betaRes)
    if (betaRes) {
      setBetaStatuses(betaRes?.betas || {})
    }
  }, [betaRes])

  useEffect(() => {
    // console.log(liveRes)
    if (liveRes) {
      setLiveStatuses(liveRes?.lives || {})
    }
  }, [liveRes])

  const initCourses = () => {
    axios
      .get('/course')
      .then((res) => setCourses(
        res.data.courses
          .sort((a, b) => (a.identifier > b.identifier && 1) || -1)
          .map(({ _id, identifier, title }) => ({
            key: _id,
            value: identifier,
            text: title,
          }))
      ))
      .catch((err) => console.error(err))
  }

  useEffect(() => {
    initCourses()
  }, [])

  const header_styles = {
    color: 'var(--blue-gray)',
    fontSize: '1.8rem',
    textAlign: isMobile ? 'center' : '',
  }

  return (
    <>
      <HelmetMetaData title="Courses | From Zero!" />
      <Container style={{ textAlign: 'center', margin: '20px auto 50px' }}>
        <FZExclamation centered={true} title="Courses" color="blue" />
        <p
          style={{
            color: 'var(--blue-gray)',
            fontWeight: 200,
            fontFamily: 'Mont Extra Light',
          }}
        >
          Choose a course to expand its contents
        </p>
      </Container>

      <Container
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {courses.length > 0 ? (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: isMobile ? 'center' : 'flex-start',
              justifyContent: isMobile ? 'center' : 'flex-start',
              width: '100%',
            }}
          >
            <Header style={header_styles}>
              Japanese From Zero!
            </Header>
            <CardDeck isMobile={isMobile}>
              {courses?.map((c, index) => (
                <React.Fragment key={c.text}>
                  {available_jfz_courses.includes(c.text) && c.value.includes('jfz') && (
                    <CourseCard
                      link={`/courses/${c.value}`}
                      title={c.text}
                      highlighted={c.value === courseBookmark?.id}
                      beta={c.value === 'kanji1' || c.value === 'kanji2'}
                    />
                  )}
                </React.Fragment>
              ))}
            </CardDeck>
            <Header style={header_styles}>Kanji From Zero!</Header>
            <CardDeck isMobile={isMobile}>
              {['Kanji From Zero! 1', 'Kanji From Zero! 2'].map((c, index) => (
                <CourseCard
                  key={c}
                  title={c}
                  link={`/courses/kanji${index + 1}`}
                  highlighted={c.value === courseBookmark?.id}
                  beta
                />
              ))}
            </CardDeck>
            <Header style={header_styles}>Korean From Zero!</Header>
            <CardDeck isMobile={isMobile}>
              {['Korean From Zero! 1', 'Korean From Zero! 2', 'Korean From Zero! 3'].map((c, index) => (
                <CourseCard
                  key={c}
                  title={c}
                  link={`/courses/korean${index + 1}`}
                  highlighted={c.value === courseBookmark?.id}
                  beta
                />
              ))}
            </CardDeck>
            {isStaffRole && (
              <>
                <Header style={header_styles}>Spanish From Zero!</Header>
                <CardDeck isMobile={isMobile}>
                  {['Spanish From Zero! 1'].map((c, index) => (
                    <CourseCard
                      key={c}
                      title={c}
                      link={`/courses/spanish${index + 1}`}
                      highlighted={c.value === courseBookmark?.id}
                      beta
                    />
                  ))}
                </CardDeck>
              </>
            )}
            {isStaffRole && (
              <>
                <Header style={header_styles}>Chinese From Zero!</Header>
                <CardDeck isMobile={isMobile}>
                  {['Chinese From Zero! 1'].map((c, index) => (
                    <CourseCard
                      key={c}
                      title={c}
                      link={`/courses/cfz${index + 1}`}
                      highlighted={c.value === courseBookmark?.id}
                      beta
                    />
                  ))}
                </CardDeck>
              </>
            )}
            <Header style={header_styles}>Supplementary Courses</Header>
            <CardDeck isMobile={isMobile}>
              {(liveStatuses.jin5 || isStaffRole) && (
                <CourseCard
                  link="/courses/jin5"
                  title="Fluent in 5!"
                  beta={betaStatuses.jin5}
                />)}
              {(liveStatuses.hitokoto || isStaffRole) && (
                <CourseCard
                  link="/courses/hitokoto"
                  title="Hitokoto"
                  beta={betaStatuses.hitokoto}
                />)}
              {(liveStatuses.ask || isStaffRole) && (
                <CourseCard
                  link="/courses/ask"
                  title="Ask a Teacher!"
                  beta={betaStatuses.ask}
                />)}
              {(liveStatuses.jtm || isStaffRole) && (
                <CourseCard
                  link="/courses/jtm"
                  title="Japanese Topics Mania!"
                  beta={betaStatuses.jtm}
                />)}
              {(liveStatuses.daily || isStaffRole) && (
                <CourseCard
                  link="/courses/daily"
                  title="Japanese Daily!"
                  beta={betaStatuses.daily}
                />)}
              {(liveStatuses.coffee || isStaffRole) && (
                <CourseCard
                  link="/courses/coffee"
                  title="Japanese Morning Coffee! LIVE NOTES"
                  beta={betaStatuses.coffee}
                />)}
              <CourseCard
                link='/course/kansai'
                title='Kansai Dialect From Zero!'
              />
            </CardDeck>
            {isStaffRole && (
              <>
                <Header style={header_styles}>FZ! Live</Header>
                <CardDeck isMobile={isMobile}>
                  {(isStaffRole || props.roles?.includes('live-student')) && (
                    <CourseCard
                      key={'FZLive'}
                      title={'From Zero! Live'}
                      link={'/courses/fzlive'}
                      highlighted={courseBookmark?.id === 'fzlive'}
                      beta
                    />
                  )}
                </CardDeck>
              </>
            )}
            {/* <Header style={header_styles}>Paid supplemental courses:</Header>
            <CardDeck isMobile={isMobile}>
              {courses?.map((c) => (
                <React.Fragment key={c.text}>
                  {purchased_courses.includes(c.text) && (
                    <CourseCard
                      link={props.courses.includes('kansai')
                        ? '/course/main'
                        : '/store/kansai'
                      }
                      title={c.text}
                      highlighted={c.value === courseBookmark?.id}
                      showDelay={0}
                    />
                  )}
                </React.Fragment>
              ))}
            </CardDeck> */}
            {(isStaffRole || window.Cypress) && (
              <>
                <Header style={header_styles}>Dev courses</Header>
                <CardDeck isMobile={isMobile}>
                  <CourseCard
                    link="/courses/test"
                    title="Test Course"
                    data-cy='test-course'
                  />
                  {isStaffRole && ['Japanese From Zero! 1 (v8)', 'Japanese From Zero! 2 (new)', 'Japanese From Zero! 3 (new)', 'Japanese From Zero! 4 (new)', 'Japanese From Zero! 5 (new)'].map((c, index) => (
                    <CourseCard
                      key={c}
                      title={c}
                      link={`/courses/japanese${index + 1}`}
                      highlighted={c.value === courseBookmark?.id}
                    />
                  ))}
                  {isStaffRole && ['Japanese From Zero! 6'].map((c, index) => (
                    <CourseCard
                      key={c}
                      title={c}
                      link={'/courses/jfz6'}
                      highlighted={c.value === courseBookmark?.id}
                    />
                  ))}
                  {isStaffRole && ['JLPT From Zero! N5', 'JLPT From Zero! N4', 'JLPT From Zero! N3', 'JLPT From Zero! N2', 'JLPT From Zero! N1'].map((c, index) => (
                    <CourseCard
                      key={c}
                      title={c}
                      link={`/courses/jlptn${5 - index}`}
                      highlighted={c.value === courseBookmark?.id}
                    />
                  ))}
                </CardDeck>
              </>
            )}
          </div>
        ) : (
          <Grid centered>
            <Loader active inline size="massive">
              Loading courses...
            </Loader>
          </Grid>
        )}
      </Container>

      {props.roles?.includes('admin') && (
        <Grid centered style={{ marginTop: '30px' }}>
          <Grid.Row>
            <Grid.Column width={8} textAlign="center">
              {newCourseForm ? (
                <NewCourseForm onSubmitted={initCourses} />
              ) : (
                <Button color="green" onClick={() => setNewCourseForm(true)}>
                  Add New Course
                </Button>
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      )}
    </>
  )
}

const mapStateToProps = (state) => ({ roles: state.auth.roles, courses: state.user.courses })

export default connect(mapStateToProps, { loadCourses, loadSubs })(CoursesPreviewPage)
